export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-align-right-ab2b941a697cc9710dda8b9a934559a9.svg";